<template>
  <div>
    <app-nav></app-nav>
    
    <div class="container-fluid">
        <div class="row">
          

    <main class="col-sm-9 ml-sm-auto col-md-10 pt-3" role="main">
        <h4 class="text-left" >Liste des titulaires</h4>     
        <div class="loading" v-if="loading">
            Loading...
        </div>       
        <div class="form-check">
        <label class="form-check-label">
            <input class="form-check-input"  type="checkbox" id="checkbox" v-model="viewInactives" >
            Montrer aussi les retraités
        </label>
        </div>
        <br>
        <router-link class="btn btn-default pull-left" :to="{name: 'TitulairesNew'} ">Nouveau titulaire</router-link>   
        <br>
        <br>
        <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                <tr>        
                    <th>#</th>
                    <th>Nom</th>
                    <th>Prenom</th>
                    <th>Actif</th>               
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="titulaire in filteredTitulaires()" :key="titulaire.node.id">     
                    <th><router-link :to="{name: 'Titulaire' , params: { id: titulaire.node.id }}">{{titulaire.node.id}}  </router-link></th>     
                    <td class="text-left">{{ s.capitalize(titulaire.node.nom) }}</td>
                    <td class="text-left">{{ s.capitalize(titulaire.node.prenom) }}</td>
                    <td class="text-left">{{ (titulaire.node.retraite)?"Non":"&#x2714;" }}</td>
                    <td><button class="btn btn-danger btn-sm" @click="deleteTitulaire(titulaire.node.id)">Suppr.</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
            
          </main>
        </div>
    </div>
  </div>
</template>
<script>
import AppNav from './AppNav'
import s from "underscore.string"
import {filter} from 'lodash'
import {
  ALL_TITULAIRES_QUERY,
  DELETE_TITULAIRE,
  UPDATE_TITULAIRE
} from '../constants/graphql'

const pageSize = 10

export default {
  name: 'titulaires',
  components: {
    AppNav,
  },
  data() {
    return {
      s: s,
      allTitulaires: [],
      viewInactives: false,
      loading: false
    }
  },
  apollo: {
    allTitulaires: {
      query: ALL_TITULAIRES_QUERY
    }
  },
  methods: {
    filteredTitulaires () {
      var self = this
      if (self.viewInactives == true) {
          return self.allTitulaires.edges       
      } else {      
      return filter(self.allTitulaires.edges, function (titulaire) {
          return titulaire.node.retraite == false
        })
      }
    },
      /*
        Don't trly suppress titulaire, just set retraite = true
      */
      deleteTitulaire(id){
        var self = this;
        this.$apollo.mutate({
          mutation: UPDATE_TITULAIRE,
          variables: {
            id: id,
            retraite: true,
          },
           refetchQueries: [{
                query: ALL_TITULAIRES_QUERY
            }]     
        }).then((data) => {
            self.$router.push({name: 'Titulaires'});
        }).catch((error) => {
          // Error
          console.error(error)
        })
      }
    }
  }

</script>
<style scoped>
body {
    padding-top: 3.5rem;
}


/*
 * Typography
 */

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}


/*
 * Sidebar
 */

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}


/* Sidebar navigation */

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}


/*
 * Dashboard
 */


/* Placeholders */

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}

.medecins-form{
    padding-bottom: 60px;
}


</style>



// WEBPACK FOOTER //
// titulaires.vue?e220122e